/**
 * Fallback vue и nuxt для большинства ошибок клиента и сервера
 * ! не гарантирует перехват всех ошибок !
 */

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:error', (error: unknown, _, info: string) => {
    if (!(error instanceof Error)) {
      useAppLogger().logError(
        `Unknown error fallback caught. Vue error info: ${info}`,
        new Error('Unknown error' + JSON.stringify(error)),
      );

      throw showError({
        message: `Unknown error fallback caught. Vue error info: ${info}`,
        fatal: true,
        data: { error, info },
      });
    }

    useAppLogger().logError(`Error fallback caught ${error.name}. Vue error info: ${info}`, error);

    throw showError({
      message: `Произошла не обработанная ошибка ${error.name}`,
      fatal: true,
      data: { error, info },
    });
  });
});
